/** @format */

'use client';
import { Button, Dialog, Flex, Heading, VisuallyHidden } from '@radix-ui/themes';
import { Cross2Icon } from '@radix-ui/react-icons';
import React from 'react';

interface DialogProps {
	headerContent: React.ReactNode | string;
	enableCloseAction: boolean;
	children: React.ReactNode;
	contentClassValue: string;
	handleDialogCloseAction: () => void;
	handleAninamtionChange: () => void;
}

const DialogContentView: React.FC<DialogProps> = (props) => (
	<Dialog.Content className={props?.contentClassValue} >
		<VisuallyHidden>
			<Dialog.Title>
				{typeof props?.headerContent === "string" ? props?.headerContent : "Dialog"}
			</Dialog.Title>
		</VisuallyHidden>
		<Flex className="relative justify-between !items-center p-4 !pl-0 pt-0">
			<Flex className="relative flex-row justify-start items-center gap-2">
				{typeof props?.headerContent === "string" ? (
					<Heading
					as='h1'
						size='3'
					>
						{props?.headerContent}
					</Heading>	
				) : (
					props?.headerContent
				)}
			</Flex>
			{props?.enableCloseAction && <Dialog.Close>
				<Button
					onClick={() => {
						props?.handleDialogCloseAction();
					}}
					variant="solid"
					radius="full"
					className="!w-8 !h-8 !p-0 !cursor-pointer absolute right-0  bg-white text-secondary-default hover:bg-primary-default/5 hover:text-primary-default"
				>
					<Cross2Icon width="20" height="20" />
				</Button>

			</Dialog.Close>}
		</Flex>
		<div className=" relative">
			{props?.children}
		</div>
	</Dialog.Content>
);

export default DialogContentView;
